<div>
    <h2 mat-dialog-title style="text-align: center;" i18n>Receipt Code</h2>  
    <mat-dialog-content id="dialog-content">
      <div class="receipt-code-container">
        <p i18n>Tap ●●●●●● to show your code.</p>
        <button class="code-toggle-btn" (click)="showCode = !showCode">
            {{ showCode ? data.code : '●●●●●●' }}
          </button>
          
  
      </div>
    </mat-dialog-content>
  
    <mat-dialog-actions align="center" style="margin-top: 15px;">
      <button
        i18n
        cdkFocusInitial
        class="button-primary"
        mat-dialog-close
        aria-label="Ok Close dialog"
      >
        OK
      </button>
    </mat-dialog-actions>
  </div>
  